import { useQuery } from "@tanstack/react-query";
import { axios } from "lib/axios";

export const getJournalEntryList = ({
  churchId,
  startDate,
  endDate,
  page,
  pageSize
}) => {
  return axios.get(
    `/churches/${churchId}/journal-entries?start_date=${startDate}&end_date=${endDate}&page=${page}&page_size=${pageSize}`
  );
};

export const useJournalEntryList = ({
  churchId,
  startDate,
  endDate,
  page,
  pageSize,
  config
} = {}) => {
  return useQuery({
    ...config,
    queryKey: [
      "journal-entry-list",
      churchId,
      startDate,
      endDate,
      page,
      pageSize
    ],
    queryFn: () =>
      getJournalEntryList({ churchId, startDate, endDate, page, pageSize }),
    select: data => data.result
  });
};
